import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-label text-primary-400 uppercase tracking-widest mb-3">
            内容分类
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">
            探索世界观全貌
          </h2>
          <p className="text-foreground-400 max-w-xl mx-auto text-sm leading-relaxed">
            六大分类维度，全方位覆盖角色、剧情、设定、创作等核心领域，助你系统化理解作品全貌
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block p-6 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-primary-500/40 transition-all duration-300 hover:bg-background-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 border border-primary-500/20 group-hover:bg-primary-500/20 group-hover:border-primary-500/40 transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-xl text-primary-400`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-600">
                  {cat.articleCount} 篇文章
                </span>
                <span className="text-xs text-primary-400 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center gap-1">
                  浏览 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}